
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const slider = '.js-product-slider';
const contentSlider = sliderElm => {
    const sliderIdentifier = sliderElm.id;
    const type = sliderElm.dataset.type;
    const slideEl = sliderElm.querySelectorAll('.content-slider__item');

    const swiper = new Swiper(`#${sliderIdentifier}`, {
        modules: [Navigation, Pagination],
        loop: false,
        spaceBetween: 16,
        slidesPerView: 1,
        navigation: {
            nextEl: '.js-swiper-next',
            prevEl: '.js-swiper-prev',
            lockClass: 'is-hidden',
            disabledClass: 'is-disabled',
        },
        pagination: {
            el: '.js-hero-slider-pagination',
            clickable: true,
            bulletClass: 'hero-slider__pagination-item',
            bulletActiveClass: 'is-active',
        },
    });

    return {
        swiper,
    };
};

const allSliders = document.querySelectorAll(slider);
allSliders.forEach(slider => contentSlider(slider));
